module.exports = __webpack_public_path__ + "static/media/stethoscope.ef12af76.svg";